module.exports = __webpack_public_path__ + "img/30.e226fc51.jpg";